module.exports = __webpack_public_path__ + "img/stackslash-inspect-large.a6040a4f.jpg";